var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReleaseComponent',{attrs:{"releaseid":this.$route.params.releaseid}})
}
var staticRenderFns = []

export { render, staticRenderFns }